/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { Nullable } from 'primereact/ts-helpers';
import { useAuthContext } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getArmadoresList } from '@/services/getListArmadores';
import { getBeach } from '@/services/getBeach';
import InputDateField from '../../InputDateField/InputDateField';
import styles from './ExchangesTableFilters.module.scss';
import { TableFilters } from '../types';
import DropdownField from '../../DropdownField/DropdownField';

type ExchangesTableFiltersProps = {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

const ExchangesTableFilters: FC<ExchangesTableFiltersProps> = ({
  filters,
  setFilters,
}) => {
  const { data: assignListDropdown } = useQuery({
    queryKey: ['armadoresListDropdown'],
    queryFn: getArmadoresList,
  });

  const { data: beach } = useQuery({
    queryKey: ['beachListDropdown'],
    queryFn: getBeach,
  });
  const { t } = useTranslation('tableFilters');
  const { userDataDecoded } = useAuthContext();

  const options = userDataDecoded?.armadores?.split(';').map((val) => {
    return {
      value: val,
      name: val,
    };
  });

  const shipownerOptions = assignListDropdown?.map((val: any) => {
    return {
      value: val.codigo,
      name: val.nombre,
    };
  });

  const shipowner =
    userDataDecoded?.armadores === '*' ? shipownerOptions : options;

  const handleFilterChange = (
    value: string | Nullable<Date>,
    field: keyof TableFilters
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
  };

  const beachOptions = [{ value: '', name: 'TODAS' }].concat(
    beach
      ? beach.map((val) => ({
          value: val.codigo,
          name: val.codigo,
        }))
      : []
  );

  return (
    <div className={styles.filtersContainer}>
      <InputDateField
        id="startAt"
        name="startAt"
        value={filters.fechaDesde}
        onChange={(e) => handleFilterChange(e, 'fechaDesde')}
        label={t('startAt')}
        className={styles.dateField}
        readOnlyInput
      />
      <InputDateField
        id="endAt"
        name="endAt"
        value={filters.fechaHasta}
        onChange={(e) => handleFilterChange(e, 'fechaHasta')}
        label={t('endAt')}
        className={styles.dateField}
        readOnlyInput
        showTime
      />
      <DropdownField
        id="shipowner"
        name="shipowner"
        multiple
        value={filters.armadores}
        onChange={(e) => handleFilterChange(e.value, 'armadores')}
        options={shipowner}
        label={t('shipowner')}
        className={styles.dropdownField}
      />
      <DropdownField
        id="beach"
        name="beach"
        value={filters.codPlaya}
        onChange={(e) => handleFilterChange(e.value, 'codPlaya')}
        options={beachOptions}
        label={t('beach')}
        className={styles.dropdownField}
      />
    </div>
  );
};

export default ExchangesTableFilters;
